import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { TypedTranslate } from '@change-corgi/core-react/i18n';

type SharingToolsCardWrapperProps = {
	Preview: React.ReactNode;
	titleKey: TranslationKey;
	descriptionKey: TranslationKey;
	primaryActionTextKey: TranslationKey;
	primaryActionOnClick: () => void;
};

export const SharingToolsCardWrapper: React.FC<SharingToolsCardWrapperProps> = ({
	Preview,
	titleKey,
	descriptionKey,
	primaryActionTextKey,
	primaryActionOnClick,
}) => {
	return (
		<div
			data-qa="sharing-tools-card-wrapper"
			className="bg-fill-information-weaker flex h-[422px] w-[295px] max-w-full flex-col gap-5 overflow-hidden rounded-xl px-5 py-6 md:h-[210px] md:w-full md:max-w-full md:flex-row-reverse md:items-center md:gap-8 md:px-8 md:py-4"
		>
			<div className="flex h-[178px] w-full shrink-0 items-center justify-center md:h-full md:w-auto md:max-w-77 md:min-w-70">
				{Preview}
			</div>
			<div className="flex w-full min-w-0 flex-col gap-5 overflow-hidden md:h-fit md:w-0 md:flex-1 md:basis-0 md:justify-around">
				<div className="flex min-w-0 flex-col gap-3 overflow-hidden">
					<Text variant="heading" size="x-small" className="wrap-break-word">
						<TypedTranslate value={titleKey} />
					</Text>
					<Text variant="body" className="wrap-break-word">
						<TypedTranslate value={descriptionKey} />
					</Text>
				</div>
				<Button
					data-qa="primary-action-button"
					className="w-full md:w-fit md:shrink-0"
					variant="secondary-solid"
					size="small"
					onClick={primaryActionOnClick}
				>
					<TypedTranslate value={primaryActionTextKey} />
				</Button>
			</div>
		</div>
	);
};
